module.exports = __webpack_public_path__ + "static/media/docmang1.a68901ca.png";